import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { SearchTermOrigin } from "@/types/search-term";

interface HoverableKeywordProps {
  word: string;
  origin?: SearchTermOrigin;
  // AUT-41 Part 3: double-click a keyword to add it to the prohibited list.
  onAddToProhibited?: (word: string) => void;
}

export function HoverableKeyword({ word, origin, onAddToProhibited }: HoverableKeywordProps) {
  const doubleClickProps = onAddToProhibited
    ? {
        onDoubleClick: () => onAddToProhibited(word),
        title: "Double-click to add to prohibited keywords",
      }
    : {};

  return (
    <HoverCard openDelay={100} closeDelay={50}>
      <HoverCardTrigger asChild>
        <span
          className="text-sm text-primary cursor-default border-b border-dotted border-primary/50 hover:border-primary transition-colors"
          {...doubleClickProps}
        >
          {word}
        </span>
      </HoverCardTrigger>
      <HoverCardContent side="top" align="center" className="w-auto max-w-[280px] p-3 space-y-1.5">
        <p className="text-xs font-medium text-foreground">{origin ? origin.keyword : word}</p>
        {origin ? (
          <div className="space-y-0.5">
            <p className="text-xs text-muted-foreground">
              Origin: <span className="text-foreground">{origin.original_phrase}</span>
            </p>
            <p className="text-xs text-muted-foreground">
              Search Vol: <span className="text-foreground font-medium">{(origin.original_phrase_search_volume ?? 0).toLocaleString()}</span>
            </p>
          </div>
        ) : (
          <p className="text-xs text-muted-foreground">Origin not recorded</p>
        )}
      </HoverCardContent>
    </HoverCard>
  );
}
